import { MdCalendarViewMonth, MdOutlineClear, MdViewList } from 'react-icons/md';
import { Button } from '@ds';
import { IconToggle } from '@ui';
import { SchedulerResourcesFilter } from '@lp/features/Scheduler/components';
import { PCCSchedulerControlFilters } from '@lp/features/Scheduler/SchedulerClinicalCoordinators/types';
import { CCResourcesWithShifts } from '@/api/apis/resources/schedule';
import { UseFiltersType } from '@/hooks/useFilters';

type SSchedulerFiltersSectionProps = {
  shiftsData: CCResourcesWithShifts;
  filters: UseFiltersType<PCCSchedulerControlFilters>;
};

export const PCCSchedulerFiltersSection = ({ shiftsData, filters: filterData }: SSchedulerFiltersSectionProps) => {
  const { filters, updateFilters } = filterData;
  const hasFilters = !!filters.resources.length && !filters.isPersonalView;

  return (
    <div className="flex items-center gap-4">
      {hasFilters && (
        <Button
          disableRipple
          size="sm"
          variant="light"
          endContent={<MdOutlineClear />}
          onClick={() => updateFilters([], 'resources')}
        >
          Clear all
        </Button>
      )}
      {!filters.isPersonalView && (
        <SchedulerResourcesFilter
          shiftsData={shiftsData}
          selectedKeys={filters.resources}
          onSelectedKeysChange={(ids) => updateFilters(ids, 'resources')}
        />
      )}
      <IconToggle
        isSelected={filters.isPersonalView}
        onValueChange={(isSelected) => updateFilters(isSelected, 'isPersonalView')}
        disableIcon={<MdViewList />}
        enableIcon={<MdCalendarViewMonth />}
      />
    </div>
  );
};
